"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasPlotPoints = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../../../utils");
var color_1 = require("../../constants/color");
var draw_point_1 = require("../../functions/draw-point");
var mouseEvent = function (fn) { return function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    fn((0, utils_1.IPos)({
        x: ev.nativeEvent.offsetX,
        y: ev.nativeEvent.offsetY
    }));
}; };
exports.CanvasPlotPoints = (0, react_1.memo)(function (_a) {
    var canvasSize = _a.canvasSize, positivePoints = _a.positivePoints, negativePoints = _a.negativePoints, cursorType = _a.cursorType, onPlot = _a.onPlot;
    var _b = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), context = _b[0], canvasRef = _b[1];
    (0, react_1.useEffect)(function () {
        if (context === undefined)
            return;
        (0, utils_1.resetAndDrawOnCanvas)(context, canvasSize, function () {
            var e_1, _a, e_2, _b;
            context.shadowBlur = 5;
            context.shadowColor = 'black';
            try {
                for (var _c = tslib_1.__values(negativePoints.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var negative = _d.value;
                    context.fillStyle = color_1.negativeColorLighter;
                    (0, draw_point_1.drawPoint)(context, negative);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            try {
                // over write negative points by positive points when overlapping
                for (var _e = tslib_1.__values(positivePoints.values()), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var positive = _f.value;
                    context.fillStyle = color_1.positiveColorLighter;
                    (0, draw_point_1.drawPoint)(context, positive);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
        });
    }, [context, canvasSize, positivePoints, negativePoints]);
    var onClick = (0, react_1.useCallback)(mouseEvent(onPlot), [onPlot]);
    var style = (0, react_1.useMemo)(function () { return ({ cursor: cursorType }); }, [
        cursorType
    ]);
    return (react_1.default.createElement("canvas", { onClick: onClick, style: style, ref: canvasRef, height: canvasSize.height, width: canvasSize.width }));
});
exports.CanvasPlotPoints.displayName = 'CanvasPlotPoints';
